<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1 ">
        <v-chip
            label
            small
            class="ma-2"
            color="secondary"
        >
          شارژ
          DF-008-1
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-spacer/>

      <v-card-text>
        <page-new :building-list="buildingList" :pay="pay" :cost="cost" :model="model" :dialog-status.sync="showDialog"/>
        <v-row>
          <v-col cols="12" md="1" v-if="can('newSmsManager') " class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                clearable
                @click:clear="clear"
                placeholder="نام مجتمع"
                v-model="searchvalue"

            />
            <v-btn fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
<!--          <v-col cols="12" md="7">-->
<!--            <b-pagination-->
<!--                v-model="skip"-->
<!--                :total-rows="paging.totalSize"-->
<!--                :per-page=take-->
<!--                first-text="اولین"-->
<!--                prev-text="<"-->
<!--                next-text=">"-->
<!--                last-text="آخرین"-->
<!--                dir="ltr"-->
<!--                limit="10"-->
<!--                @change="pageChangeHandler"-->
<!--            />-->

<!--          </v-col>-->
        </v-row>
        <v-spacer/>


        <div style=" max-width: 100%; overflow: auto;"
             class="table-responsive scroll_ my-2">
          <b-table-simple
                          :per-page=0
                          hover small caption-top>
            <b-thead>
              <b-tr>
                <b-th style="text-align: right"></b-th>
                <b-th style="text-align: right; width: 200px ">نام مجتمع</b-th>
                <b-th style="text-align: right; width: 200px ">نام پرداخت کننده</b-th>
                <b-th style="text-align: right; width: 200px">مبلغ پرداخت (ریال)</b-th>
                <b-th style="text-align: right; width: 200px ">تعداد پیامک</b-th>
                <b-th style="text-align: right; width: 200px ">نوع پرداخت</b-th>
                <b-th style="text-align: right; width: 200px ">تاریخ پرداخت</b-th>
                <b-th v-show="showCol1" style="text-align: right; width: 200px ">مانده حساب(ریال)</b-th>
                <!--                  <b-th  v-show="notShowCol3" style="text-align: right; width: 200px " >عملیات</b-th>-->
              </b-tr>
            </b-thead>

            <b-tbody v-for="(data,i) in dataItems" :key="i">
              <!-- ردیف اصلی -->
              <b-tr style="text-align: right; background-color: #e9e9eb" v-b-toggle="'collapse-'+i"
                    @click="toggleId('collapse-'+i)">
                <b-th>
                  <v-icon small v-if="!idCollapse.includes('collapse-'+i)">mdi-plus</v-icon>
                  <v-icon small v-if="idCollapse.includes('collapse-'+i)">mdi-minus</v-icon>
                </b-th>
                <b-th>{{ data.building.name }}</b-th>
                <b-th>{{ data.fullName }}</b-th>
                <b-th>{{ data.smsManagerBalance }}</b-th>
                <b-th>{{ data.countSms }}</b-th>
                <b-th>{{ data.paymentTypeText }}</b-th>
                <b-th>{{ data.payDateText }}</b-th>
                <b-th v-show="showCol1">{{ data.smsManagerBalance }}</b-th>

              </b-tr>

              <!-- ردیف زیرمجموعه -->
              <b-tr style="display: table-row" class="text-align: right">
                <td colspan="9"> <!-- تعداد ستون‌ها برابر تعداد ستون‌های ردیف اصلی -->
                  <b-collapse :id="'collapse-'+i">
                    <b-table-simple hover small caption-top>
                      <b-tbody v-for="(item,j) in data.subList" :key="j">
                        <b-tr style="text-align: right" v-b-toggle="'collapse-'+i" @click="toggleId('collapse-'+i)">
                          <b-th>
                            {{ j + 1 }}
                          </b-th>
                          <b-th style="text-align: right; width: 200px "></b-th>
                          <b-th style="text-align: right; width: 200px ">{{ item.fullName }}</b-th>
                          <b-th style="text-align: right; width: 200px ">{{ item.payment }}</b-th>
                          <b-th style="text-align: right; width: 200px ">{{ item.countSms }}</b-th>
                          <b-th style="text-align: right; width: 200px ">{{ item.paymentTypeText }}</b-th>
                          <b-th style="text-align: right; width: 200px ">{{ item.payDateText }}</b-th>
                          <b-th style="text-align: right; width: 200px " v-show="showCol1">--</b-th>
                             </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-collapse>
                </td>
              </b-tr>
            </b-tbody>


          </b-table-simple>

        </div>

      </v-card-text>

    </v-card>
  </div>
</template>

<script>
/**
 * the page for شارژ مدیریت
 */
import Service from "./Service_se";
import PageNew from "./PageNew"

export default {
  name: 'SMSManger',
  components: {PageNew},
  data() {
    return {
      model: {},
      showDialog: false,
      showCol1: false,
      showCol2: false,
      notShowCol3: true,

      dataItems: [],
      idCollapse: [],
      costTypeItems: [],
      buildingList: [],
      pay: {},
      cost: 0,
      modelId: '',
      searchvalue: '',
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'building.name', label: 'نام مجتمع',},
        {key: 'paymentAmount', label: 'مبلغ پرداخت (ریال)'},
        {key: 'countSms', label: 'تعداد پیامک'},
        {key: 'paymentTypeText', label: 'نوع پرداخت',},
        {key: 'lastPayDateText', label: 'تاریخ اخرین پرداخت'},
        {key: 'validityDateText', label: 'تاریخ اعتبار',},
      ],

    };

  },

  mounted() {
    this.$root.$on('SMSManger', () => {
      // your code goes here
      this.fillDataItems()
    })
  },

  methods: {
    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },
    forNew: function () {
      this.modelId = '';
      this.fetch()
    },
    fetch() {
      Service.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.buildingList = response.data.buildingItem
        this.cost = response.data.cost
        this.pay = response.data.pay
      })
      this.showDialog = true;
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Service.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else if (response.response.status === 409) {
                  this.$snack({
                    type: 'error',
                    message: 'در حال استفاده میباشد و امکان حذف وجود ندارد!'
                  })
                }
              })
          )
    },
    clear() {
      this.searchvalue = ""
      this.fillDataItems();
    },
    fillDataItems() {
      this.showCol1 = false
      this.showCol2 = false
      this.notShowCol3 = true
      Service.getPage( this.searchvalue).then(response => {
        this.dataItems = response.data.list
        this.paging = response.data.page
        this.costTypeItems = response.data.costTypeItems
        this.notShowCol3 = false;

      });
    },
    toggleId(id) {
      if (this.idCollapse.includes(id)) {
        const index = this.idCollapse.indexOf(id);
        if (index > -1) {
          this.idCollapse.splice(index, 1);
        }
      } else {
        this.idCollapse.push(id)
      }
    },
    clearable() {
      this.$nextTick().then(() => {
        this.searchvalue = ""
        this.fillDataItems()
      });
    },

  },

  created() {
    // this.type=this.enumCostType.SMSCredit
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}



</style>
